<template>
    <div id="appmenu" :class="{appmenu:true, appmenu_active:getmenuflag}">
        <div id="appmenubg" :class="{appmenubg:true, appmenubg_active:getmenuflag}">
            <cardlist
                v-for="data in cardlistdata"
                :key="data.id"
                :id="data.id"
                :title="data.title"
                :cardinfo="data.cardinfo"
            />
            <div class="space" style="width: 100%; height: 100px;">

            </div>
        </div>
    </div>
</template>
  
<script>
    import cardlistdata from '@/assets/js/data/cardlistdata'
    import cardlist from '@/components/common/cardlist.vue'
    import {scroller} from 'vue-scrollto/src/scrollTo'
    export default {
        data() {
            return {
                cardlistdata,
            };
        },
        components:{
            cardlist
        },
        computed:{
            getmenuflag(){
                return this.$store.state.menuflag;
            },
        },
        watch: {
            getmenuflag: function(value) {
                if (value) document.getElementsByTagName("body")[0].style.overflow = "hidden";
                else document.getElementsByTagName("body")[0].style.overflow = "auto";
            }
        },
        mounted(){
            const transition = document.getElementById('appmenu');
            transition.addEventListener(
                'transitionend',
                () => {
                    this.functionfortransition(event);
                },
                true
            );
        },
        methods:{
            functionfortransition(event){
                if(event.propertyName == 'opacity' && this.$store.state.menuflag){
                    this.cardlistdata.forEach(element => {
                        element['cardinfo'].forEach(cell => {
                            if(cell["site_name"]==this.$store.state.currentwisher){
                                const goscroll = scroller();
                                window.setTimeout(( () => 
                                    goscroll(
                                        '#'+element['id']+'anchor',
                                        500,
                                        {
                                            container: '#appmenubg'
                                        }
                                    )
                                ), 333);
                            }
                        })
                    });
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .appmenu{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        pointer-events: none;
        visibility: hidden;
        opacity: 0;
        transition: 0.333s ease-in-out;
        display: flex;
        justify-content: center;
        background-color: #FAFAFA;
        .appmenubg{
            position: relative;
            width: 100%;
            margin-top: 50px;
            //margin-bottom: 50px;
            transform: translateX(-100%);
            transition: 0.666s ease-out;
            font-family: 'Noto Sans TC';
            overflow: scroll;
            &::-webkit-scrollbar {
                display: none;
            }
        }
        .appmenubg_active{
            transform: translateX(0);
            
        }
    }
    .appmenu_active{
        visibility: visible;
        pointer-events:auto;
        opacity: 1;
        z-index: 5002;
    }
    .appmenu::-webkit-scrollbar {
        display: none;
    }
</style>